import { render, staticRenderFns } from "./MigrationEdit.vue?vue&type=template&id=4af021ba"
import script from "./MigrationEdit.vue?vue&type=script&lang=js"
export * from "./MigrationEdit.vue?vue&type=script&lang=js"
import style0 from "./MigrationEdit.vue?vue&type=style&index=0&id=4af021ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports